import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconTextAlignLeft = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="lucide lucide-align-left"
    viewBox="0 0 24 24"
    aria-label="IconTextAlignLeft"
    stroke="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M15 12H3M17 18H3M21 6H3" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconTextAlignLeft);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
